"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSelect = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const react_virtual_1 = require("@tanstack/react-virtual");
const icons_1 = require("@chakra-ui/icons");
const PageSelect = ({ onChange, pageIndex, numberOfPages, isDisabled, }) => {
    const parentRef = (0, react_1.useRef)(null);
    const virtualizer = (0, react_virtual_1.useVirtualizer)({
        count: numberOfPages,
        getScrollElement: () => parentRef.current,
        estimateSize: () => 20,
        overscan: 5,
    });
    return (react_1.default.createElement(react_2.Menu, { matchWidth: true }, ({ isOpen }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.MenuButton, { isActive: isOpen, as: react_2.Button, rightIcon: react_1.default.createElement(icons_1.ChevronDownIcon, null), isDisabled: isDisabled, borderRadius: 'full', width: '65px', fontWeight: 500, fontSize: '12px', color: '#4F4E4C', size: 'xs', bgColor: 'transparent', border: '1px solid #e2e8f0', _active: {
                bgColor: 'transparent',
            }, _hover: {
                bgColor: 'transparent',
            } }, numberOfPages === 0 ? 0 : pageIndex + 1),
        react_1.default.createElement(react_2.MenuList, { ref: parentRef, style: {
                minHeight: '50px',
                maxHeight: '200px',
                overflowY: 'auto',
                minWidth: '100%',
            } },
            react_1.default.createElement(react_2.Box, { position: "relative", h: `${virtualizer.getTotalSize()}px`, pr: '5px' }, isFinite(numberOfPages) && numberOfPages > 0
                ? virtualizer.getVirtualItems().map(virtual => (react_1.default.createElement(react_2.MenuItem, { onClick: onChange, key: virtual.index, value: virtual.index, style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: `${virtual.size}px`,
                        transform: `translateY(${virtual.start}px)`,
                    }, fontWeight: 500, fontSize: '12px' }, virtual.index + 1)))
                : null))))));
};
exports.PageSelect = PageSelect;
